export function getRootCategory(hierarchy) {
    return isRootCategory(hierarchy) ? hierarchy : getRootCategory(hierarchy.parent);
}
export function getMainCategory(hierarchy) {
    if (isRootCategory(hierarchy)) {
        return undefined;
    }
    return isMainCategory(hierarchy) ? hierarchy : getMainCategory(hierarchy.parent);
}
export function isRootCategory(hierarchy) {
    return hierarchy.category.level === 1;
}
export function isMainCategory(hierarchy) {
    return hierarchy.category.level === 2;
}
export function isFirstLevelSubcategory(hierarchy) {
    return hierarchy.category.level === 3;
}
export function isSecondLevelSubcategory(hierarchy) {
    return hierarchy.category.level === 4;
}
export function isSubcategory(hierarchy) {
    return hierarchy.category.level > 2;
}
export function isSelectedCategory(category, selectedCategory) {
    if (isRootCategory(selectedCategory)) {
        return false;
    }
    return category === selectedCategory
        ? true
        : isSelectedCategory(category, selectedCategory.parent);
}
export function findCategoryById(category, categoryId) {
    var root = getRootCategory(category);
    // breadth first search
    var edge = [root];
    while (edge.length > 0) {
        var cat = edge.shift();
        if (cat.category.id === categoryId) {
            return cat;
        }
        edge = edge.concat(cat.children);
    }
    return undefined;
}
